import {createStore, useStore as baseUseStore, Store, StoreOptions} from 'vuex';
import { InjectionKey } from 'vue';
import userData, {UserDataState} from "@/store/modules/userData";
import calendarData, { CalendarDataState} from "@/store/modules/calendarData";

export interface State {
  userData: UserDataState;
  calendarData: CalendarDataState;
}

export const key: InjectionKey<Store<State>> = Symbol();

const storeOptions: StoreOptions<State> = {
  modules: {
    userData,
    calendarData
  }
};

export const store = createStore<State>(storeOptions);

export function useStore(){
  return baseUseStore(key);
}